import React, { useEffect } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { useLoading } from '../context/LoadingContext';

export const LoadingOverlay: React.FC = () => {
  const { isLoading, setIsLoading } = useLoading();

  useEffect(() => {
    const handleLoading = (event: CustomEvent<boolean>) => {
      // setIsLoading(event.detail);
    };

    window.addEventListener('api-loading', handleLoading as EventListener);
    return () => {
      window.removeEventListener('api-loading', handleLoading as EventListener);
    };
  }, [setIsLoading]);

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
      }}
      open={isLoading}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
};
